<div class="list-container">
  <rask-list [data]="ckleverantorer">
    <rask-list-column header="{{ 'KUND_DETAIL_NAMN' | translate }}" field="namn" [sortable]="true">
      <ng-template let-row="row">
        <a href="#" (click)="showDetails($event, row)">
          {{row.namn}}
        </a>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="{{ 'KUND_DETAIL_ANLAGGNING' | translate }}" field="avdelning" [sortable]="true"></rask-list-column>
    <rask-list-column header="{{ 'KUND_DETAIL_BESOKSADRESS' | translate }}" field="besokPostortadress" [sortable]="true" [nowrap]="true" [tooltip]="true"></rask-list-column>
    <rask-list-column header="{{ 'KUND_DETAIL_HUVUDKOD' | translate }}" field="huvudkod" [sortable]="true"></rask-list-column>
    <rask-list-column header="{{ 'KUND_DETAIL_INTERNNUMMER' | translate }}" field="internnummer" [sortable]="true" [nowrap]="true" [tooltip]="true"></rask-list-column>
    <rask-list-column header="{{ 'KUND_DETAIL_BESKRIVNING' | translate }}" field="beskrivning" [sortable]="true"></rask-list-column>
    <rask-list-column header="Befraktare" field="befraktare">
      <ng-template let-value>
        @if (value) {
          <i class="far fa-check"></i>
        }
      </ng-template>
    </rask-list-column>
    <rask-list-column header="{{ 'KUND_DETAIL_ORGNUMMER' | translate }}" field="orgNummer" [sortable]="true"></rask-list-column>
    <rask-list-column header="{{ 'KUND_DETAIL_AKTIV' | translate }}" field="aktiv">
      <ng-template let-value>
        @if (value) {
          <i class="far fa-check"></i>
        }
      </ng-template>
    </rask-list-column>
  </rask-list>
</div>
